module.exports = Promise.all([__parcel__import__("khlRc"), __parcel__import__("fT2QV")]).then(() => parcelRequire('g36Vt'));